import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { TillPage } from '../../../features/pos/till-page'

/** The till: full screen (no sidebar or top bar), for all-day use at the counter. */
export const Route = createFileRoute('/_app/pos/')({
  staticData: { fullScreen: true },
  beforeLoad: ({ context }) => requirePermission(context.session, 'pos.sell'),
  component: TillPage,
})
